/**
 * This file is a part of the Promvc framework.
 * 
 * (c) ThemePlexi
 * 
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

+function ( $ )
{
	/**
	 * Declare private properties
	 * @private
	 */

	var NAME        = 'promvc-app-error',
		VERSION     = '2.0.0',
		DATA_KEY    = 'promvc.app.error',
		initialised = false;

	/**
	 * The client-side legacy errors js.
	 * 
	 * @since 1.0.0
	 */
	function App( element )
	{
		this._element = element;
		this._wrapper = document.getElementById( 'appMountPoint' );
		this._contentSection = document.getElementsByClassName( 'o-section-error' )[ 0 ];
		this._contentAlign = document.getElementsByClassName( 'c-concord__align--error' )[ 0 ];

		this._params = {
			isModUi: $( document.documentElement ).attr( 'data-ui' ) === 's-mod',
			ua: $( document.documentElement ).attr( 'data-ua' )
		};
	}

	// public

	App.prototype.init = function ()
	{
		if ( initialised ) {
			return;
		}

		// Handle layout adjustments
		this.adjustLayout();

		// register init
		initialised = true;
	};

	App.prototype.adjustLayout = function ()
	{
		// adjust initial height
		if ( this._wrapper && ! this._params.isModUi ) {
			this._wrapper.style.height = window.innerHeight + 'px';
			this._wrapper.style.minHeight = window.innerHeight + 'px';
		}

		// adjust concord slider pane heights
		if ( this._contentAlign && ! this._params.isModUi ) {
			let border = this._contentSection.offsetHeight - this._contentSection.scrollHeight;
			this._contentAlign.style.height = ( window.innerHeight - border ) + 'px';
		}
	};

	// static

	App._jQueryInterface = function ( config )
	{
		return this.each( function () {
			var data = $( this ).data( DATA_KEY );

			if ( ! data ) {
				data = new App( this );
				$( this ).data( DATA_KEY, data );
			}

			if ( config === 'init' ) {
				data[ config ]();
			}
		});
	};

	/**
	 * --------------------
	 * Application Load
	 * --------------------
	 */

	$( function ()
	{	
		$( 'body' ).each( function () {
			var $wrapper = $( this );
			App._jQueryInterface.call( $wrapper, 'init' );
		});

	});

}( jQuery );